/**
 * InstallerDashboardRoute — DEPRECATED redirect to canonical Installer Portal.
 *
 * Per the Installer Execution-First Flow (P12.2), `InstallerExecutionView` is
 * the single source of truth for the install checklist, and ContractorPortal
 * already delegates to it when a job is selected. The legacy `/installer-dashboard`
 * "Push Mode" page duplicated that surface in a parallel shell.
 *
 * To deliver one canonical surface (Portal = home, tap a job = checklist),
 * this route now redirects to `/installer-portal`. The `?observeAs=` query
 * param is preserved so SuperAdmin Observer Mode (P12.2) continues to work.
 *
 * The legacy `InstallerDashboardPage` and `InstallerDashboardCockpit` files
 * remain in the repo for reference but are no longer reachable.
 */
import { Navigate, useSearchParams } from "react-router-dom";

export default function InstallerDashboardRoute() {
  const [searchParams] = useSearchParams();
  const observeAs = searchParams.get("observeAs");
  const target = observeAs ? `/installer-portal?observeAs=${observeAs}` : "/installer-portal";
  return <Navigate to={target} replace />;
}
